import { GatsbyImage, ImageDataLike, getImage } from 'gatsby-plugin-image';
import React from 'react';
import * as styles from './heroHeaderImage.module.scss';
import { SanityBlock, SanityLocaleString } from '../../../../graphql-types';
import { usePageContext } from '../../../hooks/contexts/usePageContext';
import { RichText } from '../richText/RichText';

interface IHeroHeaderImageProps {
  image: ImageDataLike;
  alt?: string | null;
  title?: SanityLocaleString;
  description?: (SanityBlock | null)[];
}

export const HeroHeaderImage = ({ image, alt, title, description }: IHeroHeaderImageProps) => {
  const { lang } = usePageContext();
  const gatsbyImage = getImage(image);
  const titleDisplay = title?.[lang];
  const descriptionDisplay = description?.[lang];

  return (
    <div className={styles.wrapper}>
      <div className={styles.image}>
        {gatsbyImage && (
          <>
            <GatsbyImage
              image={gatsbyImage}
              alt={alt ?? 'tours tourisme placeholder'}
              loading="eager"
            />
            <div className={styles.shadow} />
          </>
        )}
      </div>
      <div className={styles.contentWrapper}>
        <section>
          {titleDisplay && <h1 className={styles.title}>{titleDisplay}</h1>}
          {descriptionDisplay && (
            <RichText className={styles.description} value={descriptionDisplay} />
          )}
        </section>
      </div>
    </div>
  );
};
